module.exports = __webpack_public_path__ + "static/media/greenSearch.2fd27dbd.svg";